const dic =obj=>{
    const _list= Object.keys(obj).map(k=>{
        return {value:k,label:obj[k]}
    })
    return {...obj,_list}
}
export default {
    sex:dic({1:'男',2:'女'}),
}